import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Pagination from 'components/CncUI/Table/Pagination';
import Loader from 'components/Loader';

import CheckLogs from './CheckLogs';
import CustomPaginationActions from './CustomPaginationActions';
import parseMainStatus from './utils/parseMainStatus';
import parseChecks from './utils/parseChecks';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    borderRadius: 4,
    padding: 16,
  },
  success: {
    background: palette.cncUI.alert.green.powder,
    border: `solid 1px ${palette.cncUI.alert.green.primary}`,
  },
  error: {
    background: palette.cncUI.alert.red.powder,
    border: `solid 1px ${palette.cncUI.alert.red.primary}`,
  },
}));

const DisplayChecks = ({ checks, status, page, setPage, loading }) => {
  const classes = useStyles();
  const mainStatus = parseMainStatus(status);
  const statusLogs = parseChecks(checks);
  const mainClassName = clsx(
    classes.root,
    classes[mainStatus?.type || 'error'],
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography className={mainClassName} variant="h5">
          {mainStatus?.message}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Pagination
          noPerPageOptions
          rowsPerPageOptions={[90]}
          ActionsComponent={CustomPaginationActions}
          labelDisplayedRows={() => ''}
          component="div"
          count={checks.length}
          rowsPerPage={90}
          onChangePage={(_, value) => setPage(value)}
          page={page}
        />
      </Grid>
      {loading ? (
        <Grid item xs={12}>
          <Loader />
        </Grid>
      ) : (
        Object.keys(statusLogs).map(key => (
          <Grid item xs={12} key={key}>
            <CheckLogs name={key} logs={statusLogs[key]} />
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default DisplayChecks;
